module.exports = __webpack_public_path__ + "frontend/images/cards/gold/visual-bg.jpg?c8ce5d60b148c8ce31b76e96e0ae3761";